import {
  getPinnableToolById,
  PINNED_TOOLS_MAX,
  PINNED_TOOLS_STORAGE_KEY,
} from "../../data/dashboard/pinnableToolsCatalog";

export function normalizeOnboardingPinnedToolIds(toolIds) {
  if (!Array.isArray(toolIds)) {
    return [];
  }

  const seen = new Set();
  const normalized = [];

  for (const rawId of toolIds) {
    if (typeof rawId !== "string" || !getPinnableToolById(rawId) || seen.has(rawId)) {
      continue;
    }
    seen.add(rawId);
    normalized.push(rawId);
    if (normalized.length >= PINNED_TOOLS_MAX) {
      break;
    }
  }

  return normalized;
}

export function savePinnedToolsFromOnboarding(toolIds) {
  const normalized = normalizeOnboardingPinnedToolIds(toolIds);
  if (normalized.length === 0) {
    return [];
  }

  try {
    localStorage.setItem(PINNED_TOOLS_STORAGE_KEY, JSON.stringify(normalized));
  } catch {
    // Ignore storage failures in private browsing.
  }

  return normalized;
}
